import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    "SickKids Hospital": {
      jobTitle: "Machine Learning Developer @",
      duration: "Sep 2024 - Present",
      desc: [
        "Built automated CT protocol recommendation system, reducing clinical variability",
        "Fine-tuned LLMs locally for clinical text-to-protocol mapping with privacy preservation",
        "Deployed MLOps pipeline with FastAPI, Docker, Azure Cloud, CI/CD automation",
        "Developed pediatric liver MRI processing pipeline for lesion segmentation tasks",
        "Organized hospital-wide ML reading group for researchers and engineers"
      ]
    },
    "York University": {
      jobTitle: "Research Assistant – Machine Learning & Computer Vision @",
      duration: "Sep 2022 - Aug 2024",
      desc: [
        "Implemented synchronized motion capture and eye-tracking setup (12+ hours, 74 participants)",
        "Developed diffusion-based generative model for realistic eye movement simulation",
        "Designed four-level evaluation framework using behavioral gaze principles",
        "Built Unity visualizer with avatars and Three.js data inspection tool"
      ]
    },
    "IPM Institute for Research": {
      jobTitle: "Machine Learning Developer @",
      duration: "Jan 2020 - Mar 2021",
      desc: [
        "Developed 2D-to-3D garment overlay pipeline using DensePose and 3D warping",
        "Engineered pose-aware garment alignment with edge detection and silhouette matching",
        "Prototyped virtual try-on applications with reusable testing pipelines"
      ]
    },
    "ASR Gooyesh Pardaz Company": {
      jobTitle: "Software Developer Intern @",
      duration: "May 2020 - Sep 2020",
      desc: [
        "Developed Django-based website for Persian QA dataset collection",
        "Designed PostgreSQL database for user-submitted questions and metadata",
        "Applied Agile methodologies (Scrum, Sprint Planning) for efficient delivery"
      ]
    },
    "University of Toronto-IMICS Lab": {
      jobTitle: "Research Intern – NLP and Digital Humanities @",
      duration: "May 2021 - Oct 2021",
      desc: [
        "Built unsupervised pipeline for Persian poetry analysis and historical trend detection",
        "Developed topic modeling system with LDA, BERT embeddings, and autoencoder fusion",
        "Collaborated with computational linguists for interpretability and context"
      ]
    },
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection delay={`${i + 1}00ms`}>
                  <li key={i}>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
